// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"9a2db51e","268":"5daadf9b","453":"ef5d4db2","758":"ea0b38b4"}[chunkId] + ".chunk.js";
};